import React, { Component } from 'react';
import { downloadTranslations } from '../Networking/TranslationGetter';
import LoginAuth from '../Pages/LoginAuth';

let self;

class Auth extends Component {
    constructor(props) {
        super(props);
        self = this;

        this.getTranslation = this.getTranslation.bind(this);

        this.state = {
            language: null,
            credentials: {
                email: '',
                password: ''
            },

            clientId: props.clientId,
            redirectUri: props.redirectUri,
            state: props.state,
            projectId: 'sikom-home',

            translations: null,
        }
    }


    getTranslation(key) {
        if (this.state.translations != null) {
            const value = this.state.translations[key];
            if (value != null) {
                return value;
            } else {
                console.log("Translation for " + key + " not found.");
                return key;
            }
        } else {
            /*
             This will occur the first time the login page renders, as translations
             have not yet been downloaded. As soon as the translations are set,
             the page will re-render and update the fields.
            */
            return key;
        }
    }

    // It is important that credentials, value code flag and auto login flag are set
    // in componentWillMount. If it was set in componentDidMount, the Login content
    // would render before the state with the new values has actually been updated.
    componentWillMount() {

        // If no language is defined, we set Norwegian by default
        let inputLanguage = this.props.language;
        if (this.props.language == null) {
            inputLanguage = 'nb-NO';
        }
        //inputLanguage = navigator.language || navigator.userLanguage;
        this.setAndDownloadLanguage(inputLanguage);
    }


    setAndDownloadLanguage(inputLanguage) {
        let userLang;
        if (inputLanguage === null) {
            userLang = 'nb-NO';
        } else {
            userLang = inputLanguage;
        }

        console.log("Language: " + userLang);
        const onTranslationsDownloaded = function onTranslationsDownloaded(translations) {
            console.log("Translations downloaded. Setting translation data");
            self.setState({
                language: userLang,
                translations: translations
            });
        };

        const onError = function onError() {
            console.log("Translation download failed!");
        };

        downloadTranslations(userLang, onTranslationsDownloaded, onError);
    }

    render() {

        const content = <LoginAuth
            clientId={this.state.clientId}
            getTranslation={this.getTranslation}
            language={this.state.language}
            state={this.state.state}
            setAndDownloadLanguage={this.setAndDownloadLanguage}/>

        return (
            <div className="Main">
                {content}
            </div>
        );
    }
}

export default Auth;




// WEBPACK FOOTER //
// ./src/Main/Auth.js